module.exports = __webpack_public_path__ + "static/media/thruxton.5e531ae7.jpg";